import { fromJS, List } from 'immutable';

export function finish( state, { sportId, participant } ) {
    const items = state.getIn( [ 'collections', sportId, 'items' ], List() ).map( item => {
        return item.get( 'id' ) === participant.id ? fromJS( participant ) : item;
    } );

    return state.setIn( [ 'collections', sportId, 'items' ], items );
}
